/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const appointmentRowBookedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentRowConflictsItemEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentRowConflictsItemStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentRowDurationMinutesMin = -9007199254740991
export const appointmentRowDurationMinutesMax = 9007199254740991

export const appointmentRowEndAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentRowIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const appointmentRowLocationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const appointmentRowPfMessageOneAttemptsMin = 0
export const appointmentRowPfMessageOneAttemptsMax = 9007199254740991

export const appointmentRowPfMessageOneSentAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentRowProviderIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const appointmentRowSourceOneRegExp = new RegExp('^[a-z0-9_-]{1,40}$')
export const appointmentRowStartAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const appointmentRowStartDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const appointmentRowVisitTypeIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)

export const AppointmentRow = zod.object({
  bookedAt: zod.iso.datetime({ offset: true }).regex(appointmentRowBookedAtRegExp),
  conflicts: zod.array(
    zod.object({
      end: zod.iso.datetime({ offset: true }).regex(appointmentRowConflictsItemEndRegExp),
      kind: zod.enum(['appointment', 'blocked']),
      location: zod.string(),
      reason: zod.string(),
      start: zod.iso.datetime({ offset: true }).regex(appointmentRowConflictsItemStartRegExp),
    }),
  ),
  coverage: zod.object({
    code: zod.string(),
    name: zod.string(),
  }),
  durationMinutes: zod.int().min(appointmentRowDurationMinutesMin).max(appointmentRowDurationMinutesMax),
  endAt: zod.iso.datetime({ offset: true }).regex(appointmentRowEndAtRegExp),
  id: zod.uuid().regex(appointmentRowIdRegExp),
  location: zod.object({
    id: zod.uuid().regex(appointmentRowLocationIdRegExp),
    name: zod.string(),
  }),
  pfAppointmentId: zod.string(),
  pfMessage: zod.union([
    zod.object({
      attempts: zod.int().min(appointmentRowPfMessageOneAttemptsMin).max(appointmentRowPfMessageOneAttemptsMax),
      lastErrorCode: zod.string().nullable(),
      sentAt: zod.union([
        zod.iso.datetime({ offset: true }).regex(appointmentRowPfMessageOneSentAtOneRegExp),
        zod.null(),
      ]),
      status: zod.enum(['pending', 'sending', 'sent', 'failed', 'skipped']),
    }),
    zod.null(),
  ]),
  provider: zod.object({
    color: zod.string(),
    credentials: zod.string(),
    id: zod.uuid().regex(appointmentRowProviderIdRegExp),
    name: zod.string(),
  }),
  source: zod.union([zod.string().regex(appointmentRowSourceOneRegExp), zod.null()]),
  sourceSaved: zod.boolean(),
  startAt: zod.iso.datetime({ offset: true }).regex(appointmentRowStartAtRegExp),
  startDate: zod.string().regex(appointmentRowStartDateRegExp),
  visitType: zod.object({
    id: zod.uuid().regex(appointmentRowVisitTypeIdRegExp),
    name: zod.string(),
    telehealth: zod.boolean(),
  }),
})

export type AppointmentRow = zod.input<typeof AppointmentRow>
export type AppointmentRowOutput = zod.output<typeof AppointmentRow>
